module.exports = __webpack_public_path__ + "static/media/me.9247c90c.jpg";